import React from "react"
import { useScrollAnim } from "components/hooks/hooks"
import CardProduct from "components/global/card-product/card-product"
import { Slider } from "@components/anti"
import { F_Q_PRODUCT } from "lib/function"
import { useRouter } from "next/router"

const HomeRecent = ({ wishlists, locale }) => {
  const [trigger, anim] = useScrollAnim()
  const [state, setState] = React.useState({
    recent: null,
    recentProducts: null,
  })
  const { locale: currentLocale } = useRouter()

  React.useEffect(() => {
    const fetchRecentProducts = async () => {
      let data = window.localStorage.getItem("recent-view")
      if (data) {
        let products = JSON.parse(data).reverse()

        // Fetch updated data for each product
        const updatedProducts = await Promise.all(
          products.slice(0, 15).map(async (product) => {
            const response = await F_Q_PRODUCT(
              {
                id: product.id,
                lang: currentLocale,
              },
              process.env.INIT_TOKEN
            )
            return response?.data?.product
          })
        )

        // Filter out any failed fetches
        const validProducts = updatedProducts.filter((product) => !!product)

        setState((prev) => ({
          ...prev,
          recent: products,
          recentProducts: validProducts,
        }))
      }
    }

    fetchRecentProducts()
  }, [currentLocale])

  return (
    <>
      <section className="sc-home-recent" ref={trigger}>
        {state.recentProducts?.length > 0 ? (
          <div className={`container ${anim(1)}`}>
            <h2 className={`title-section`}>
              {locale === "id" ? "Baru Dilihat" : "Recently Viewed"}
            </h2>
            <div className="home-recent-product">
              <div className="">
                <Slider
                  showInitial={5}
                  showXxlDown={5}
                  showXlDown={4}
                  showLgDown={3}
                  showMdDown={2}
                  showSmDown={2}
                  dotsInitial={false}
                  arrowsInitial={true}
                  nextArrow={<CustomNextArrow />}
                  prevArrow={<CustomPrevArrow />}
                >
                  {state.recentProducts.map((item, i) => (
                    <CardProduct
                      className={`${anim(1 + i)}`}
                      key={item.id}
                      {...item}
                      imgAlt={`recent-product-${i}`}
                      noHeartIcon
                      listName="Recently Viewed"
                      index={i + 1}
                    />
                  ))}
                </Slider>
              </div>
            </div>
          </div>
        ) : null}
      </section>
    </>
  )
}

const CustomPrevArrow = (props) => {
  const { className, onClick } = props
  return (
    <div className={className} onClick={onClick}>
      <div className="wrapper-arrow">
        <span className="air ai-chevron-left" />
      </div>
    </div>
  )
}

const CustomNextArrow = (props) => {
  const { className, onClick } = props
  return (
    <div className={className} onClick={onClick}>
      <div className="wrapper-arrow">
        <span className="air ai-chevron-right" />
      </div>
    </div>
  )
}

export default HomeRecent
